import React from 'react'
import './styles.scss'
import Button from './../buttons/Button';

const ButtonsNav = (props) => {

    return (
        <div className={`buttons-row nav-buttons ${props.bg ? 'bg' : ''}`}>
            <div className="triangle-custom" />
            <div className="wrapper">
                <div className="col">
                    <Button title="Back" class={`white reverse`} arrowPrevBlack={ true } setFunction={ () => props.prev() } />
                </div>
                {props.next &&
                    <div className="col">
                        <Button title={props.titleNext ? props.titleNext : "Next step"} class={`${props.bg ? 'black' : 'white'} ${props.classNext}`} arrowBlack={ props.bg ? false : true } arrow={props.bg ? true : false} setFunction={ () => props.next() } />
                    </div>
                }
            </div>
        </div>
    )
}

export default ButtonsNav;